<template>
  <div>
    <div v-if="itemObj.businessType == 3">
      <template v-if="itemObj.type == 4">
        <div class="engineer-box-cen">
              <div class="flex mar-b">
                  <div class="flex mar-r">
                      <p class="key">资金来源：</p>
                      <p class="val" v-if="itemObj.fundSource != '其他'">
                          {{ itemObj.fundSource ? itemObj.fundSource : "/" }}
                      </p>
                      <p class="val" v-else>
                          {{ itemObj.otherSource ? itemObj.otherSource : "/" }}
                      </p>
                  </div>
                  <div class="flex">
                      <p class="key">经营类型：</p>
                      <p class="val">
                          {{ itemObj.manageType ? itemObj.manageType : "/" }}
                      </p>
                  </div>
              </div>
              <div class="flex mar-b">
                  <div class="flex">
                      <p class="key">预计工期：</p>
                      <p class="val" style="width: auto;" v-if="itemObj.bidStartTime && itemObj.bidEndTime">
                          {{ Number(itemObj.bidStartTime) | formatDay }} 至
                          {{ Number(itemObj.bidEndTime) | formatDay }}
                      </p>
                      <p class="val" v-else>/</p>
                  </div>
              </div>
              <div class="flex">
                  <p class="key">项目介绍：</p>
                  <p class="val1">{{ itemObj.remark ? itemObj.remark : "/" }}</p>
              </div>
        </div>
      </template>
      <template v-else>
        <el-table :data="itemObj.goodsLists">
          <el-table-column
              v-for="(itt,index) in goodsHeader"
              :key="`${index}${new Date().getTime()}`"
              :label="itt.translate"
              :prop="itt.name"
              show-overflow-tooltip
          ></el-table-column>
        </el-table>
      </template>
    </div>
    <div v-else>
      <template>
        <el-table :data="itemData">
          <el-table-column
              v-for="(itt,index) in goodsHeaderArr"
              :key="`${index}${new Date().getTime()}`"
              :label="itt.translate"
              :prop="itt.name"
              show-overflow-tooltip
          ></el-table-column>
        </el-table>
      </template>
    </div>
  </div>
</template>

<script>
export default {
  name: "",
  components: {
  },
  props: {
     itemObj: {
          type: Object,
      },
  },
  data() {
    return {
      goodsHeaderArr:[],
      goodsHeader:[],
      itemData:[]
    };
  },
  watch: {
    itemObj:{
      deep:true,
      immediate:true,
      handler(val) {
        if(val.isOfferDisplay == 0 || val.isDisplay == 0){
          if (val.businessType == 3) {
            this.goodsHeader = val.goodsHeader;
          } else {
            this.goodsHeaderArr = val.goodsHeader && val.goodsHeader.filter( item => {
              return item.name != 'minPrice'
            }).filter( item => {
              return item.name != 'maxPrice'
            })
          }
        }else{
          if (val.businessType == 3) {
            this.goodsHeader = val.goodsHeader;
          } else {
            this.goodsHeaderArr = val.goodsHeader;
          }
        }
        if (val.businessType == 3) {
          if(val.goodsList){
            let arr = [];
              val.goodsList.map((list, index) => {
                  let objData = {};
                  list && list.map((itt, i) => {
                    objData[itt.name] = itt.value != null ? itt.value : '/';
                  })
                  arr.push(objData)
              })
            val.goodsLists = arr
          }
        } else {
          if(val.goodsList){
            let arr = [];
              val.goodsList.map((list, index) => {
                  let objData = {};
                  list && list.map((itt, i) => {
                      objData[itt.name] = itt.value;
                  })
                  if (arr.length < 3) {
                    arr.push(objData)
                  }
              })
            this.itemData = arr
          }
        }
      }
    }
  },
 
  created() {},
  mounted() {
    
    // console.log(this.goodsHeaderArr,'this.goodsHeaderArr');
    
  }
};
</script>
<style lang="scss" scoped>
.engineer-box-cen {
    margin: 15px;
    height: 120px;
    font-size: 14px;
    .key {
        color: #666;
    }
    .val {
        width: 167px;
        color: #333;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        line-height: 20px;
    }
    .val1 {
        width: 445px;
        color: #333;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        line-height: 20px;
    }
    .mar-b {
        margin-bottom: 20px;
    }
}
.bidding {
  width: 1178px;
  background-color: #fff;
  display: flex;
  flex-wrap: wrap;
  padding-left: 20px;
  border-top: none;
  .bidding-list {
    float: left;
    cursor: pointer;
    border: 1px solid #e4e7ed;
    margin-right: 20px;
    margin-bottom: 20px;
    width: 567px;
    height: 340px;
    &:nth-child(even) {
      margin-right: 0;
    }
    &:hover {
      border-bottom: none;
      transform: translateY(-19px);
      transition: all 0.2s ease-in-out;
      .footer {
          height: 72px;
      }
    }
    .footer {
        height: 110px;
        padding: 20px 10px;
        font-size: 14px;
        .com-box{
          display: flex;
          justify-content: space-between;
          align-items: center;
        }

        p {
            margin-bottom: 10px;
            color: #333;
            img {
                width: 14px;
                height: 17px;
                vertical-align: text-bottom;
            }
            span {
                color: #666;
            }
        }
    }


    .company {
      font-size: 14px;
      font-weight: 400;
      color: #666666;
      height: 50px;
      line-height: 50px;
      text-overflow: ellipsis;
      overflow: hidden;
      white-space: nowrap;
    }
    .min-price{
      font-size: 14px;
      font-weight: 400;
      color: #666666;
      margin-right: 18px;
    }
    .head {
        height: 68px;
        width: 100%;
        background: #f5f7fa;
        overflow: hidden;
        box-sizing: border-box;
        position: relative;
        border-bottom: 1px solid #e4e7ed;
        .title {
            width: 490px;
            line-height: 25px;
            padding-top: 10px;
            margin-left: 10px;
            font-size: 16px;
            color: #333;
            font-weight: normal;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 1;
            // white-space: nowrap;
            text-overflow: ellipsis;
            overflow: hidden;
        }
        .titleInfo {
            font-size: 14px;
            .moneySpan {
                color: #666666;
                margin-left: 10px;
            }
        }
        .i-status {
            display: block;
            position: absolute;
            top: 0;
            right: 0;
        }
    }
    .data-list {
      margin: 0px 10px;
      height: 154px;
      overflow: hidden;
      border-bottom: 1px dashed #e4e7ed;

      .noshuju{
          text-align: center;
          img{
              padding-top:25px;
              padding-bottom: 9px;
          }
          .text-info{
              font-size: 14px;
              color: #666666;
          }
      }
    }
    /deep/.data-list .el-table td {
      padding: 7px 0;
      border: 0;
    }
    /deep/.data-list .el-table th {
      padding: 7px 0;
      border: 0;
    }
    /deep/.el-table:before {
      height: 0;
    }
    /deep/.el-table .cell{
        color: #333333!important;
    }
    /deep/.el-table .el-table__row .cell{
        color: #666666!important;
    }
  }
  .line {
    border: 1px solid #b79255;
  }
}
.blue {
  background-color: #409ee9;
}
</style>
